import { UserFilterTemplatesResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import type { OptionType } from '../../types/forms.type';
import { AdapterInterface } from '../../types/global';

import BaseAdapter from './baseAdapter';

export default class GetUserFilterTemplates extends BaseAdapter<UserFilterTemplatesResponse[]> implements AdapterInterface {
  rawResponse: UserFilterTemplatesResponse[];

  async adaptResponse(): Promise<OptionType[]> {
    await this.fetchApiResponse('/api/user-filter-templates', HTTPMethod.Get);
    return this.displayResponse();
  }

  displayResponse(): Promise<OptionType[]> {
    return Promise.resolve(this.rawResponse.map((template) => ({ value: template.template_id.toString(), label: template.filter_template_name })));
  }
}
